/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Design_Settings_SidebarInputs */

const en_admin_design_settings_sidebar = /** @type {(inputs: Admin_Design_Settings_SidebarInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Design`)
};

const de_admin_design_settings_sidebar = /** @type {(inputs: Admin_Design_Settings_SidebarInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Design`)
};

/**
* | output |
* | --- |
* | "Design" |
*
* @param {Admin_Design_Settings_SidebarInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const admin_design_settings_sidebar = /** @type {((inputs?: Admin_Design_Settings_SidebarInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Design_Settings_SidebarInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_admin_design_settings_sidebar(inputs)
	return en_admin_design_settings_sidebar(inputs)
});